<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="content-bg" v-bind:class="{ second: isSecond }">
      <div id="content">
        <div class="img conpic" v-bind:class="{ 'img-second': isSecond }">
          <img :src="imgurl"/>
        </div>
        <div class="detail" v-bind:class="{ text: !isSecond, 'text-second': isSecond }">

          <span class="headline">{{slogan}}</span>
          <div id="description">
            <span><p>{{description}}</p></span>
          </div>
        </div>

        <div class="clear"></div>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'homeServiceIntro',
    props: ['isSecond', 'slogan', 'description', 'imgurl'],
    mounted() {
      window.addEventListener('scroll', this.animation);
    },
    methods: {
      animation: function () {
        let scrTop = document.body.scrollTop
          // console.log('-------------' + scrTop)
        let winHei = document.body.clientHeight
          // console.log('-------------' + scrTop)
        let domTop = $('.conpic').offset().top
        $('.conpic').each(function () {
          let _this = $(this)
          let domTop = $(this).offset().top - scrTop
          console.log('-------------'  + domTop);
          if (domTop < 900) {
            _this.find('img').css({
              'left': '0px',
              'opacity': '1'
            });
          }
        })
        
      }
    }
  }
</script>

<style scoped>
 .clear{
  clear: both;
 }
  div.content-bg {
    /*width: 1100px;*/
    width: 100%;
    display: flex;
    margin: auto;
    background-color: rgb(255, 255, 255);
    color: rgb(73,73,73);
  }

  div.second {
    background-color: rgb(240, 246, 254);
  }

  div#content {
    width: 980px;
    margin: 0 auto;
    height: 700px;
  }

  div.img {
    margin-top: 100px;
    height: 500px;
    line-height: 500px;
    float: left;
    width: 50%;
    position: relative;
  }

  div.img img{
  float: left;
  margin-top: 40px;
  margin-left: 40px;
  position: absolute;
  opacity: 0;
  top: 0;
  left: 150px;
  transition:left 2s ease,opacity 2s ease;
  -moz-transition:left 2s ease,opacity 2s ease; /* Firefox 4 */
  -webkit-transition:left 2s ease,opacity 2s ease; /* Safari and Chrome */
  -o-transition:left 2s ease,opacity 2s ease; /* Opera */
  }
  .detail {
    margin-top: 288px;
    margin-bottom: 50px;
  }

  div.text-second {
    float: left;
    margin-left: 40px;
  }

  div.img-second {
    float: right;
  }

  .headline {
    font-weight: normal;
    font-size: 48px;
    /*color: #1ebbe4;*/
    font-family: PingFangSC, "PingFang SC Semibold", "PingFang SC";
    font-style: normal;
  }

  div#description {
    font-family: 'Helvetica', 'Helvetica';
    font-size: 24px;
    white-space: pre;
    width: 426px;
    margin-top: 15px;
  }

  div.text {
    float: right;
    margin-left: 50px;
  }

  p {
    margin: auto;
    white-space: pre-line;
  }


</style>



// WEBPACK FOOTER //
// HomeServiceIntro.vue?5e13a5f8